import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */

export const { Types, Creators } = createActions({
  crmRequest: [],
  postCrm: ['data'],
  crmSuccess: ['data'],
  crmError: ['err']
});

/* Initial State */

export const INITIAL_STATE = Immutable({
  data: [],
  loading: false,
  error: false
});

/* Reducers */

export const request = state => state.merge({ loading: true });

export const success = (state, { data }) => state.merge({ data, error: false, loading: false });

export const error = state => state.merge({ loading: false, error: true });

/* Reducers to types */

export default createReducer(INITIAL_STATE, {
  [Types.CRM_REQUEST]: request,
  [Types.CRM_SUCCESS]: success,
  [Types.CRM_ERROR]: error
});
